import { render, staticRenderFns } from "./ShutterDamageSeverity.vue?vue&type=template&id=130b12c2&scoped=true"
import script from "./ShutterDamageSeverity.vue?vue&type=script&lang=ts"
export * from "./ShutterDamageSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130b12c2",
  null
  
)

export default component.exports